<app-navbar-style-two></app-navbar-style-two>
<div class="privacy-policy-section">
  <div class="container">
    <div class="policy-header">
      <h1>Privacy Policy</h1>
      <p>Your privacy is important to us. Here’s how we collect, use, and protect your information.</p>
    </div>

    <div class="policy-content">
      <div class="policy-item">
        <h4>1. Information We Collect</h4>
        <ul>
          <li>Name, contact number, email address, shipping address, and order history.</li>
          <li>Browsing behavior through cookies for better user experience.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>2. Use of Information</h4>
        <ul>
          <li>To process and deliver your orders.</li>
          <li>To provide customer support and respond to inquiries.</li>
          <li>To send order updates, offers, or related communication.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>3. Data Security</h4>
        <ul>
          <li>We use secure servers and encryption protocols to safeguard your data.</li>
          <li>Your personal information is never sold or shared unless required by law.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>4. User Rights</h4>
        <ul>
          <li>You may request access to, correction, or deletion of your personal data anytime.</li>
          <li>Please contact our support team for any data-related concerns.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
